const WithRoles = ({ requiredRoles, assignedRoles, children }) => {
  if (requiredRoles.some(role => assignedRoles.includes(role))) {
    return children
  } else return null
}

export default WithRoles
